import { z } from 'zod';
import type { Product } from './types';

const productSchema = z
  .object({
    id: z.string().min(1),
    name: z
      .string()
      .nullish()
      .transform((value) => value ?? ''),
    quantity: z
      .union([z.number(), z.string().min(1)])
      .transform(Number)
      .refine((value) => Number.isFinite(value) && value >= 0),
    unit: z
      .union([z.string(), z.number().finite()])
      .nullish()
      .transform((value) => (value == null ? undefined : String(value))),
  })
  .passthrough();

// Keep usable rows for display, but never silently save a truncated product list.
export function normalizeOrderProducts(value: unknown): {
  products: Product[];
  incomplete: boolean;
} {
  if (!Array.isArray(value)) return { products: [], incomplete: true };
  let incomplete = value.length === 0;
  const products = value.flatMap((item) => {
    const parsed = productSchema.safeParse(item);
    if (parsed.success) return [parsed.data];
    incomplete = true;
    return [];
  });
  return { products, incomplete };
}
